<template>
  <Page>
    <template #title>Рейтинг регионов</template>

    <PageContent>
      <BaseTable class="mb-10" :columns="columns" :items="items" />

      <BasePagination />
    </PageContent>
  </Page>
</template>

<script>
  import Page from '@/components/layouts/main/page/index';
  import BaseTable from '@/components/global/base-table/index';
  import BasePagination from '@/components/global/base-pagination/index';
  import PageContent from '@/components/layouts/main/page/PageContent';

  export default {
    name: 'RatingPage',

    components: {
      Page,
      BaseTable,
      PageContent,
      BasePagination,
    },

    data() {
      return {
        columns: [
          {
            name: 'Наименование региона',
            slug: 'region_name',
          },
          {
            name: 'Количество МСЗ, шт',
            slug: 'all_cnt',
          },
          {
            name: 'Федеральных МСЗ',
            slug: 'federal_cnt',
          },
          {
            name: 'Территориальных МСЗ',
            slug: 'territorial_cnt',
          },
        ],

        items: [],
      };
    },
  };
</script>
